"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.supportedLanguages = exports.strings = void 0;
const supportedLanguages = exports.supportedLanguages = {
  english: {}
};
const strings = exports.strings = {
  registration: {
    submitButton: "Sign up",
    heading: "Sign Up"
  }
};